'use strict';

var queryString = require('query-string');
var Helpers = require('./helpers');

var getPPCData = {
  getQueryData: function getQueryData() {
    var useTripappQueryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (typeof window === 'undefined') return false;
    var search = window.location.search;
    if (useTripappQueryString) {
      var hash = window.location.hash;
      var identifierIndex = hash.indexOf('?');
      search = identifierIndex === -1 ? '' : hash.slice(identifierIndex + 1);
    }
    search.replace(/\+/g, ' ') // Replace plus with spaces
    .replace(/%\s/g, '%25') // Replace single percent with encoded version
    .replace(/%$/, '%25') // Replace percentages at end with encoded version
    .replace(/%&/g, '%25&'); // Replace percentages at end of sections with encoded version
    var parsed = queryString.parse(search);
    if (parsed.adcode) {
      parsed.adcode = parsed.adcode.toUpperCase();
    }
    return parsed;
  },
  searchQueryStringAndSet: function searchQueryStringAndSet(searchArray, useTripappQueryString) {
    if (!searchArray) return false;
    var qs = this.getQueryData(useTripappQueryString);
    var value = false;
    if (Object.keys(qs).length) {
      searchArray.map(function (item) {
        if (item.match('email') && qs[item]) {
          // if plain text email, redirect hasn't kicked in yet so we aren't sending a hash.
          if (qs[item].match(/(.+)(@|%40|%2540)(.+).(.+)/)) return;
          Helpers.hashToEmail(qs[item], function (value) {
            Helpers.setCookie('email', value);
          });
        } else {
          if (qs[item]) value = qs[item];
        }
      });
    }
    return value;
  },
  ppcData: function ppcData() {
    var dataObj = this.getQueryData();
    if (!dataObj) return false;
    var data = {
      ppcmsg: dataObj.ppcmsg || '',
      adcode: dataObj.adcode || '',
      lgpStyleSplit: dataObj.lgp_style_split || 'alternative',
      keyword: dataObj.keyword || ''
    };
    return data;
  }
};

module.exports = getPPCData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/static-site-generator-shared/plugins/lib/ppc.js
// module id = 474
// module chunks = 119